import {
  Box,
  Center,
  Container,
  Group,
  Loader,
  SimpleGrid,
  Tabs,
  Text,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPackages } from "../../../../services/package";

import PlanCard from "../../../../components/PlanCard";
import { dateFormat2 } from "../../../../utils";
import { getAllStaff } from "../../../../services/staff";
import useStyles from "./style";
import SettingsPackageCard from "../../../../components/SettingsPackageCard";
import ActiveSubCard from "../../../../components/ActiveSubCard";
import SettingPaymentMethodCard from "../../../../components/SettingPaymentMethodCard";
import UpcomingBillingCard from "../../../../components/UpcomingBillingCard";
import SubscriptionDetailsCard from "../../../../components/SubscriptionDetailsCard";
import { getConnectedAccounts } from "../../../../services/payment";

const Payment = () => {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => {
    return state.profile;
  });
  const [packages, setPackages] = useState([]);
  const [activeTab, setActiveTab] = useState(
    profile?.subscription?.subscriptionType || "month",
  );
  const [loadingPackages, setLoadingPackages] = useState(false);
  const [connected, setConnected] = useState([]);
  const [upcomingInvoice, setUpcomingInvoice] = useState(null);
  const [loadingAccounts, setLoadingAccounts] = useState(false);

  const packageFn = async () => {
    setLoadingPackages(true);
    const resp = await getPackages(profile?.user?.id);
    if (resp) {
      let tempPackages = resp?.packages;

      const sortedByCost = tempPackages.sort((a, b) => {
        return Number(a.cost) - Number(b.cost);
      });

      setLoadingPackages(false);
      setPackages(sortedByCost);
    } else {
      loadingPackages(false);
    }
  };

  useEffect(() => {
    packageFn();
    getAllConnected();
    getAllStaff("activeStaff");
  }, []);

  const getAllConnected = async () => {
    setLoadingAccounts(true);
    let { accounts, upcomingInvoice } = await getConnectedAccounts();
    setConnected(accounts);
    setUpcomingInvoice(upcomingInvoice);
    setLoadingAccounts(false);
  };

  return (
    <Box className={classes.wrapperContainer}>
      <Tabs
        variant="pills"
        className={classes.monthlyAndYearlyTab}
        value={activeTab}
        onTabChange={(value) => setActiveTab(value)}
      >
        <Tabs.List>
          <Tabs.Tab value="month">Monthly</Tabs.Tab>
          <Tabs.Tab value="year">Yearly</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value={activeTab}>
          <p className={classes.accHdng}>Accounts</p>
          <Box className={classes.contentWrapper}>
            <SimpleGrid cols={3} spacing={20} className={classes.pkgGrid}>
              {loadingPackages ? (
                <Group cols={2}>
                  <Loader color="yellow" size={"md"} />
                  <Text>Loading, Please Wait...</Text>
                </Group>
              ) : (
                packages
                  ?.filter(
                    ({ type, duration }) =>
                      type !== "skypoint" && duration === activeTab,
                  )
                  ?.map((item) => {
                    const isFreePackage = item?.name === "Free";
                    if (
                      isFreePackage &&
                      profile?.subscription?.packageId?.name !== "Free"
                    ) {
                      return null;
                    }

                    return (
                      <SettingsPackageCard
                        allPackages={packages}
                        activeId={profile?.subscription?.packageId}
                        packageId={item?.id}
                        plan={item}
                        title={item?.name}
                        price={item?.cost}
                        duration={item?.duration}
                        level={item?.level}
                        stripePlanId={item?.stripeId}
                        onPlanChanged={getAllConnected}
                        desc={
                          isFreePackage
                            ? `${item?.staff} Staff Members, ${item?.facility} Facility, ${item?.patient} Patients & ${item?.dailyUpdates} Daily Updates`
                            : undefined
                        }
                        btn={
                          Number(item?.level) >
                          Number(profile?.subscription?.packageId?.level)
                            ? "Upgrade Plan"
                            : "Select Plan"
                        }
                        isUpgradePlan={
                          Number(item?.level) >
                          Number(profile?.subscription?.packageId?.level)
                        }
                        billing={
                          activeTab === "year"
                            ? `${dateFormat2(
                                profile?.subscription?.startedAt,
                                true,
                              )} - ${dateFormat2(
                                profile?.subscription?.expiredAt,
                                true,
                              )}`
                            : `${dateFormat2(
                                profile?.subscription?.startedAt,
                                false,
                              )} - ${dateFormat2(
                                profile?.subscription?.expiredAt,
                                false,
                              )}`
                        }
                      />
                    );
                  })
              )}
            </SimpleGrid>
            <ActiveSubCard />
            <SubscriptionDetailsCard />
            <SettingPaymentMethodCard
              connected={connected}
              loadingAccounts={loadingAccounts}
              getAllConnected={getAllConnected}
            />
            <UpcomingBillingCard
              connected={connected}
              upcomingInvoice={upcomingInvoice}
              loadingAccounts={loadingAccounts}
            />
          </Box>
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};

export default Payment;
